import { z } from 'zod';
import { scopeSchema } from './scope.js';
import { PERMISSION_CODES } from './permissions.js';
export const createRoleSchema = z.object({
    code: z.string().regex(/^[a-z0-9-]{3,60}$/, 'Kod faqat kichik harf, raqam va tire dan iborat bo\'ladi'),
    name: z.string().min(3).max(150),
    description: z.string().max(1000).optional(),
});
export const updateRoleSchema = createRoleSchema.partial().omit({ code: true });
export const setRolePermissionsSchema = z.object({
    permissions: z
        .array(z.string())
        .max(200)
        .refine((list) => list.every((p) => PERMISSION_CODES.includes(p)), {
        message: 'Noma\'lum ruxsat kodi',
    }),
});
export const createAssignmentSchema = z.object({
    roleId: z.string().regex(/^\d+$/),
    scope: scopeSchema,
    validFrom: z.coerce.date().optional(),
    validTo: z.coerce.date().nullable().optional(),
    reason: z.string().max(500).optional(),
});
/**
 * Mavjud biriktiruvni TAHRIRLASH — amalda faqat doirasi o'zgaradi.
 *
 * O'chirib qayta qo'shish bilan bir xil natija bermaydi: biriktiruvning
 * `id` si audit jurnalida qoladi va "kimga qachon berilgan" zanjiri uzilmaydi.
 * Rol esa o'zgarmaydi — boshqa rol boshqa biriktiruv, aralashtirilsa qatorning
 * tarixi ma'nosini yo'qotardi.
 */
export const updateAssignmentSchema = z.object({
    scope: scopeSchema.optional(),
    validTo: z.coerce.date().nullable().optional(),
    reason: z.string().max(500).nullable().optional(),
});
//# sourceMappingURL=rbac.js.map